export enum CourtLayout {
  HIGH_SCHOOL = 'HIGH_SCHOOL',
  FIBA = 'FIBA',
  NBA = 'NBA',
  NCAA = 'NCAA',
}
